<template>
    <div id="calendrier" v-if="!isLoading">
        <div class="choix-date">
            <div class="arrow left" v-on:click="choixDate_previousClick"></div>
            <span>{{ calendarLabel }}</span>
            <div class="arrow right" v-on:click="choixDate_nextClick"></div>
        </div>

        <div class="calendrier" v-bind:class="{ admin: view_isAdmin }">
            <div>
                <span>L</span><!--
                --><span>M</span><!--
                --><span>M</span><!--
                --><span>J</span><!--
                --><span>V</span><!--
                --><span>S</span><!--
                --><span>D</span>
            </div>

            <div><!--
                --><span v-for="creneaux_jour in creneaux_mois" v-bind:data-index="creneaux_jour.index"
                    v-on:click="calendarItem_onClick" v-bind:class="calendarItem_bindClass(creneaux_jour.index)">
                        <template v-if="creneaux_jour.day">
                            {{ creneaux_jour.day }}
                            <p v-if="view_isAdmin">{{ creneaux_jour.nb_creneaux_reservation }}/{{ creneaux_jour.nb_creneaux_available }}</p>
                        </template>
                        <template v-else>
                            &nbsp;
                            <p v-if="view_isAdmin">&nbsp;</p>
                        </template>
                    </span><!--
            --></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import Loader from './Loader.vue';

export default {
  name: "Calendrier",
  components: {
      
  },
  data: () => ({
      isLoading: true,
      todayMonth: null,
      todayYear: null,
      todayDay: null,
      calendarMonth: null,
      calendarYear: null,
      calendarLabel: null,
      previousMonth: null,
      nextMonth: null,
      creneaux_mois: null,
      currentDay: null,
      currentIndex: null
  }),
  props: {
      view_isAdmin: { type: Boolean, default: false },
      view_scenarioSlug: { type: String, default: null }
  },
  methods: {
      calendarItem_bindClass: function(index) {
          if (typeof index == undefined) {
              return;
          }

          var result = { active: this.creneaux_mois[index].day && this.currentDay == this.creneaux_mois[index].day };

          var type = this.creneaux_mois[index].type;
          // on associe le type seulement s'il n'est pas empty ou si c'est empty sur la première ligne (première semaine du calendrier)
          if (type !== 'empty') {
                if (this.view_isAdmin && type == 'not_available') {
                    type = 'not_available_admin';
                }
              /*if (this.view_isAdmin) {
                type = 'available';
              }*/
              result[type] = true;
          }
          return result;
      },
      calendarItem_onClick: function(event) {
          var index = event.target.getAttribute('data-index');
          if (!this.view_isAdmin && this.creneaux_mois[index].type !== 'available' && this.creneaux_mois[index].type !== 'last_chance') {
              return;
          }

          this.currentIndex = index;
          if (this.currentDay == this.creneaux_mois[this.currentIndex].day) {
              this.currentDay = null;
              this.calendarItem_bindClass(this.currentIndex);

              this.$emit('calendrier_dayUnselected');
          } else {
              this.currentDay = this.creneaux_mois[this.currentIndex].day;
              this.calendarItem_bindClass(this.currentIndex);

              var isToday = this.currentDay == this.todayDay && this.calendarMonth == this.todayMonth && this.calendarYear == this.todayYear;
              var data = {
                  isToday: isToday,
                  calendarLabel: this.calendarLabel,
                  calendarDay: this.currentDay,
                  calendarMonth: this.calendarMonth,
                  calendarYear: this.calendarYear,
                  calendarIndex: this.currentIndex,
                  creneaux: this.creneaux_mois[this.currentIndex].creneaux,
                  creneaux_sets: this.creneaux_mois[this.currentIndex].creneaux_sets,
                  nb_rooms_reservation: this.creneaux_mois[this.currentIndex].nb_rooms_reservation,
                  nb_rooms_available: this.creneaux_mois[this.currentIndex].nb_rooms_available
              };
              this.$emit('calendrier_daySelected', data);
          }
      },
      choixDate_previousClick: function(event) {
          this.current_label = null;
          this.creneaux_mois = null;

          this.$emit('calendrier_dayUnselected');

          this.isLoading = false;

          var headers = {};
          if (this.view_isAdmin) {
              var token = localStorage.getItem('admin-token');
              headers['Authorization'] = `Basic ` + token;
          }
          axios
            .get('https://api.lockquest.fr/creneaux/' + (this.view_scenarioSlug ? this.view_scenarioSlug + '/' : '') + this.previousMonth + '?' + new Date().getTime(), { cache: false, headers: headers })
                .then((response) => {
                    this.todayMonth = response.data.current_month;
                    this.todayYear = response.data.current_year;
                    this.todayDay = response.data.current_day;
                    this.calendarLabel = response.data.calendar_label;
                    this.calendarMonth = response.data.calendar_month;
                    this.calendarYear = response.data.calendar_year;
                    this.previousMonth = response.data.previous_month;
                    this.nextMonth = response.data.next_month;
                    this.creneaux_mois = response.data.creneaux;

                    this.isLoading = false;
                })
                .catch((error) => {

                });
      },
      choixDate_nextClick: function(event) {
          this.current_label = null;
          this.creneaux_mois = null;

          this.$emit('calendrier_dayUnselected');

          this.isLoading = false;

          var headers = {};
          if (this.view_isAdmin) {
              var token = localStorage.getItem('admin-token');
              headers['Authorization'] = `Basic ` + token;
          }
          axios
            .get('https://api.lockquest.fr/creneaux/' + (this.view_scenarioSlug ? this.view_scenarioSlug + '/' : '') + this.nextMonth + '?' + new Date().getTime(), { cache: false, headers: headers })
                .then((response) => {
                    this.todayMonth = response.data.current_month;
                    this.todayYear = response.data.current_year;
                    this.todayDay = response.data.current_day;
                    this.calendarLabel = response.data.calendar_label;
                    this.calendarMonth = response.data.calendar_month;
                    this.calendarYear = response.data.calendar_year;
                    this.previousMonth = response.data.previous_month;
                    this.nextMonth = response.data.next_month;
                    this.creneaux_mois = response.data.creneaux;

                    this.isLoading = false;
                })
                .catch((error) => {

                });
      },
      reloadCalendrier: function(index) {
          this.isLoading = false;

          var headers = {};
          if (this.view_isAdmin) {
              var token = localStorage.getItem('admin-token');
              headers['Authorization'] = `Basic ` + token;
          }
          axios
            .get('https://api.lockquest.fr/creneaux/' + (this.view_scenarioSlug ? this.view_scenarioSlug + '/' : '') + this.calendarMonth + '/' + this.calendarYear + '?' + new Date().getTime(), { cache: false, headers: headers })
                .then((response) => {
                    this.todayMonth = response.data.current_month;
                    this.todayYear = response.data.current_year;
                    this.todayDay = response.data.current_day;
                    this.calendarLabel = response.data.calendar_label;
                    this.calendarMonth = response.data.calendar_month;
                    this.calendarYear = response.data.calendar_year;
                    this.previousMonth = response.data.previous_month;
                    this.nextMonth = response.data.next_month;
                    this.creneaux_mois = response.data.creneaux;

                    this.isLoading = false;

                    var isToday = this.currentDay == this.todayDay && this.calendarMonth == this.todayMonth && this.calendarYear == this.todayYear;
                    var data = {
                      isToday: isToday,
                      calendarLabel: this.calendarLabel,
                      calendarDay: this.currentDay,
                      calendarMonth: this.calendarMonth,
                      calendarYear: this.calendarYear,
                      calendarIndex: this.currentIndex,
                      creneaux: this.creneaux_mois[index].creneaux,
                      creneaux_sets: this.creneaux_mois[index].creneaux_sets,
                      nb_rooms_reservation: this.creneaux_mois[index].nb_rooms_reservation,
                      nb_rooms_available: this.creneaux_mois[index].nb_rooms_available
                    };
                    this.$emit('calendrier_daySelected', data);
                })
                .catch((error) => {

                });
      },
      initializeCalendrier: function(year, month, day) {
        var headers = {};
        if (this.view_isAdmin) {
            var token = localStorage.getItem('admin-token');
            headers['Authorization'] = `Basic ` + token;
        }

        var url = 'https://api.lockquest.fr/creneaux' + (this.view_scenarioSlug ? '/' + this.view_scenarioSlug : '');
        if (year && month && day) {
            url = url + '/' + month + '/' + year;
        }

        axios
            .get(url + '?t=' + new Date().getTime(), { cache: false, headers: headers })
                .then((response) => {
                    this.todayMonth = response.data.current_month;
                    this.todayYear = response.data.current_year;
                    this.todayDay = response.data.current_day;
                    this.calendarLabel = response.data.calendar_label;
                    this.calendarMonth = response.data.calendar_month;
                    this.calendarYear = response.data.calendar_year;
                    this.previousMonth = response.data.previous_month;
                    this.nextMonth = response.data.next_month;
                    this.creneaux_mois = response.data.creneaux;

                    this.isLoading = false;
                })
                .catch((error) => {

                });
      }
  }
}
</script>
